var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"max-width":"1400px"}},[_c('DashboardHeader'),_c('div',{staticClass:"banner-headline banner-login text-center bgoverlay"},[_c('RecoveryForm')],1),_c('HomeFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }